import React from "react";
import { Image } from "semantic-ui-react";
import Icon from "assets/files/folder.png";

const DirectoryIcon = (props) => {
  return <Image src={Icon} className="file-icon" {...props} />;
};

export default DirectoryIcon;
